import React, { useState, useEffect } from 'react';
import { Menu, User, LogOut } from 'lucide-react';
import logo from '../../assets/img/56.png';
import GestionAccesos from './GestionAccesos';
import GestionUsuarios from './GestionUsuarios';

const DashboardAdministrador = ({ onLogout, userName = 'Usuario', menuItems: externalMenuItems }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeSection, setActiveSection] = useState('accesos');

  const [menuItems, setMenuItems] = useState([
    { id: 'usuarios', label: 'Gestión de Usuarios' },
    { id: 'accesos', label: 'Gestión de Accesos' }
  ]);

  useEffect(() => {
    if (Array.isArray(externalMenuItems) && externalMenuItems.length > 0) {
      setMenuItems(externalMenuItems.map(m => ({ id: m.clave || m.id, label: m.etiqueta || m.label })));
      setActiveSection((externalMenuItems[0].clave || externalMenuItems[0].id));
    }
  }, [externalMenuItems]);

  const renderContent = () => {
    switch (activeSection) {
      case 'accesos':
      case 'admin_accesos':
      case 'Gestión de Accesos':
        return <GestionAccesos />;
      case 'usuarios':
      case 'admin_usuarios':
      case 'Gestión de Usuarios':
        return <GestionUsuarios />;
      default:
        return (
          <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-800 mb-6 capitalize">
              {menuItems.find(item => item.id === activeSection)?.label}
            </h1>

            <div className="bg-white rounded-lg shadow-md p-8">
              <p className="text-gray-600">
                Contenido de {menuItems.find(item => item.id === activeSection)?.label}
              </p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`bg-white shadow-lg transition-all duration-300 ${sidebarOpen ? 'w-64' : 'w-0'
          } overflow-hidden`}
      >
        <div className="flex flex-col h-full">
          {/* Header del Sidebar */}
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <img
                src={logo}
                alt="EBID Logo"
                className="w-10 h-10 object-contain flex-shrink-0"
              />
              <div>
                <h2 className="font-bold text-lg text-gray-800">{userName}</h2>
              </div>
            </div>
          </div>

          {/* Sección de rol */}
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex items-center space-x-2">
              <User size={20} className="text-gray-600" />
              <span className="font-semibold text-gray-800">Administrador</span>
            </div>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 overflow-y-auto py-4">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                className={`w-full text-left px-6 py-3 transition-colors ${activeSection === item.id
                    ? 'bg-blue-50 border-l-4 border-blue-600 text-blue-600 font-medium'
                    : 'text-gray-700 hover:bg-gray-50'
                  }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Botón de cerrar sesión */}
          <div className="p-6 border-t border-gray-200">
            <button onClick={onLogout} className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors">
              <LogOut size={20} />
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Bar */}
        <div className="bg-white shadow-sm">
          <div className="h-3" style={{ backgroundColor: '#1e3a6f' }}></div>
          <div className="px-6 py-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Menu size={24} className="text-gray-700" />
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto p-8">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default DashboardAdministrador;